import { render } from "./BlockSocioContato.vue?vue&type=template&id=646e7efe"
import script from "./BlockSocioContato.vue?vue&type=script&lang=js"
export * from "./BlockSocioContato.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockSocioContato.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "646e7efe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('646e7efe', __exports__)) {
    console.log('reload')
    api.reload('646e7efe', __exports__)
  }
  
  module.hot.accept("./BlockSocioContato.vue?vue&type=template&id=646e7efe", () => {
    console.log('re-render')
    api.rerender('646e7efe', render)
  })

}


export default __exports__